import type { QueryKey } from '@tanstack/react-query';
import type { GetTransactionsPhoenixParams } from './api';

export const TRANSACTIONS_PHOENIX_KEY = (
  params?: GetTransactionsPhoenixParams
): QueryKey => ['transactions-phoenix', params ?? {}];
